import { FilterTypeKey, FilterType, IEntityFilter, INumberFilter } from '../../components/filters-menu/filters';
import { BidderApi } from '../../apis/bidder.api';
import { Statuses } from '../../enums/status';

export const bidderDomainsFilters = new Map<FilterTypeKey, FilterType>([
	[
		'entityFilters',
		{
			id: {
				columnName: 'Campaign number',
				cellKey: 'campaign_id',
				isClientFilter: true,
				autocompleteCallback: async () => {
					return await BidderApi.getCampaigns().then(res => {
						return res.campaigns.map(campaign => ({
							label: campaign.id,
							value: campaign.id,
						}));
					});
				},
			},
		} as IEntityFilter,
	],
	[
		'numberFilters',
		{
			paused_in_cache: { columnName: 'Paused In Cache', isClientFilter: true, cellKey: 'paused_in_cache' },
			domains_in_trash: { columnName: 'Domains In Trash', isClientFilter: true, cellKey: 'domains_in_trash' },
		} as INumberFilter,
	],

	[
		'stringFilters',
		{
			black_list_filter: { columnName: 'Black List', isClientFilter: true, cellKey: 'black_list_filter' },
			white_list_filter: { columnName: 'White List', isClientFilter: true, cellKey: 'white_list_filter' },
		},
	],

	[
		'enumFilters',
		{
			status: {
				columnName: 'Status',
				cellKey: 'status',
				enumOptions: [
					{ value: Statuses.Active, label: 'Active' },
					{ value: Statuses.Paused, label: 'Paused' },
					{ value: Statuses.NoBalance, label: 'No Balance' },
					{ value: Statuses.New, label: 'New' },
					{ value: Statuses.Ended, label: 'Ended' },
				],
				deletable: true,
			},
		},
	],
]);
